<div class="unmatched-barcodes">
  <!-- Header -->
  <div class="row mb-4 align-items-center">
    <div class="col-md-7">
      <h4>Unmatched Barcodes</h4>
      <p class="text-muted">Barcodes scanned at the POS that did not match any catalog product</p>
    </div>
    <div class="col-md-5 text-end d-flex align-items-center justify-content-end gap-2">
      <span class="text-muted" *ngIf="!isLoading">
        {{ totalItems }} barcode{{ totalItems !== 1 ? 's' : '' }} found
      </span>
      <button class="btn btn-outline-secondary btn-sm" (click)="loadBarcodes()">
        <nb-icon icon="refresh-outline"></nb-icon>
        Refresh
      </button>
      <button
        class="btn btn-danger btn-sm"
        [disabled]="isLoading || items.length === 0"
        (click)="clearAll()">
        <nb-icon icon="trash-2-outline"></nb-icon>
        Clear All
      </button>
    </div>
  </div>

  <!-- Table -->
  <nb-card>
    <nb-card-body class="p-0">
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="table-light">
            <tr>
              <th>Barcode</th>
              <th class="text-center">Scan Count</th>
              <th>First Scanned</th>
              <th>Last Scanned</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items; trackBy: trackById">
              <td>
                <div class="d-flex align-items-center gap-2">
                  <span class="font-monospace">{{ item.barcode }}</span>
                  <button
                    class="btn btn-sm btn-ghost p-0 copy-btn"
                    (click)="copyBarcode(item.barcode)"
                    nbTooltip="Copy barcode"
                    title="Copy barcode">
                    <nb-icon icon="copy-outline" class="text-muted"></nb-icon>
                  </button>
                </div>
              </td>
              <td class="text-center">
                <span class="badge bg-secondary">{{ item.count }}</span>
              </td>
              <td class="text-nowrap">
                {{ item.firstScannedAt | date:'dd/MM/yyyy HH:mm' }}
              </td>
              <td class="text-nowrap">
                {{ item.lastScannedAt | date:'dd/MM/yyyy HH:mm' }}
              </td>
              <td class="text-end">
                <button
                  class="btn btn-sm btn-outline-danger"
                  (click)="dismiss(item._id)"
                  nbTooltip="Dismiss this barcode">
                  <nb-icon icon="close-outline"></nb-icon>
                  Dismiss
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="text-center p-4">
        <nb-spinner size="large"></nb-spinner>
        <p class="mt-2 text-muted">Loading unmatched barcodes...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="!isLoading && errorMessage" class="text-center p-4">
        <nb-icon icon="alert-circle-outline" class="text-danger" style="font-size: 2rem;"></nb-icon>
        <p class="mt-2 text-danger">{{ errorMessage }}</p>
        <button class="btn btn-outline-secondary btn-sm" (click)="loadBarcodes()">
          Try Again
        </button>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && !errorMessage && items.length === 0" class="text-center p-5">
        <nb-icon icon="checkmark-circle-2-outline" style="font-size: 2.5rem;" class="text-success mb-2"></nb-icon>
        <h5>No unmatched barcodes</h5>
        <p class="text-muted">All scanned barcodes matched catalog products — no gaps to review.</p>
      </div>

      <!-- Pagination -->
      <div
        *ngIf="!isLoading && totalPages > 1"
        class="d-flex justify-content-between align-items-center p-3 border-top">
        <span class="text-muted">
          Showing {{ (currentPage - 1) * pageSize + 1 }} to
          {{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }} barcodes
        </span>
        <div>
          <button
            class="btn btn-outline-secondary me-2"
            [disabled]="currentPage === 1"
            (click)="onPageChange(currentPage - 1)">
            Previous
          </button>
          <span class="me-2">Page {{ currentPage }} of {{ totalPages }}</span>
          <button
            class="btn btn-outline-secondary"
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(currentPage + 1)">
            Next
          </button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>
